import { Box, Typography } from "@mui/material"

export default function ReviewSummary(props) {
    const { fdlData, cameraID, intentID, children} = props;

    const container = {
        gridColumnStart: '1',
        gridColumnEnd: '13',
        backgroundColor: 'rgba(107, 164, 125, 0.3)',
        padding: '20px',
        marginTop: '-5px',
        marginBottom: '-10px',
        color: 'white',
        overflow: 'auto'
    }

    let thisFD;

    // If we have valid fd, form submitted prior
    if (fdlData !== undefined) {
        let fdlJSON = JSON.parse(fdlData);
        let cameraArray = fdlJSON['contexts'][0]['canvases'];

        // Find the framing decision that matches this camera and framing intent
        for (let element in cameraArray) {
            if (cameraArray[element]['id'] === cameraID) {
                let fdArray = cameraArray[element]['framing_decisions'];
                for (let decision in fdArray) {
                    if (fdArray[decision]['framing_intent_id'] === intentID) {
                        thisFD = `ID: ${fdArray[decision]['framing_intent_id']}
Dimensions: ${fdArray[decision]['dimensions']['width']} x ${fdArray[decision]['dimensions']['height']} 
Anchor Point: ${fdArray[decision]['anchor_point']['x']}, ${fdArray[decision]['anchor_point']['y']}
Protection Dimensions: ${fdArray[decision]['protection_dimensions']['width']} x ${fdArray[decision]['protection_dimensions']['height']}
Protection Anchor Point: ${fdArray[decision]['protection_anchor_point']['x']}, ${fdArray[decision]['protection_anchor_point']['y']}
                    `
                    } else {}
                }
            }
            else {}
        }
    }

    return (
        <div style={container}>
            <Box>
                <pre>{thisFD}</pre>
                {props.children}
            </Box>
        </div>
    )   
}
